import { displayToast } from "../modules/utils";
import { Modal } from "bootstrap";
import { initializeModals, sendAppsignalError } from "../modules/utils";

export default class AjaxModal {
  constructor(node) {
    this.trigger = node; // Button that triggers the modal
    this.fetchUrl = this.trigger.dataset.modalUrl === undefined ? this.trigger.href : this.trigger.dataset.modalUrl;

    this.fetchModal();
  }

  fetchModal() {
    fetch(this.fetchUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.text();
        }

        throw new Error("Something went wrong");
      })
      .then((html) => {
        this.removeExistingModals();
        this.initializeModal(html);

        window.Beyuna.initClasses(this.modalWrapperElement); // load all custom js
        initializeModals(this.modalWrapperElement);

        // We do this afterwards because the ConfirmationModal has to be created first.
        if (this.confirmationModalElement) {
          this.generateConfirmationModalEventListeners();
        } else {
          this.modalElement.addEventListener("hidden.bs.modal", () => {
            this.disposeModal();
          });
        }
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.trigger.dataset.errorMessage);
        sendAppsignalError(e, "AjaxModal", {
          response: this.response,
        });
      });
  }

  removeExistingModals() {
    const existingModals = document.querySelectorAll(".js-modal");
    const confirmationModals = document.querySelectorAll("[data-js-class='confirmation-modal']");

    const allModals = [...existingModals, ...confirmationModals];

    allModals.forEach((modal) => {
      const modalInstance = Modal.getInstance(modal);

      modal.parentElement.remove(); // Remove the modal wrapper
      modalInstance.dispose();
    });
  }

  initializeModal(html) {
    this.modalWrapperElement = document.createElement("div");
    this.modalWrapperElement.innerHTML = html;
    document.body.appendChild(this.modalWrapperElement);
    this.modalElement = this.modalWrapperElement.querySelector(".js-modal");

    this.confirmationModalElement = this.modalWrapperElement.querySelector("[data-js-class='confirmation-modal']");
    this.formElement = this.modalWrapperElement.querySelector("[data-js-class='ajax-form']");

    this.modal = new Modal(this.modalElement);

    if (this.formElement) {
      this.formElement.addEventListener("ajax:successful-post", () => {
        this.handleSuccesfulSubmission();
      });
    }

    this.modal.show();

    window.dispatchEvent(new Event("modal:loaded"));
  }

  generateConfirmationModalEventListeners() {
    this.confirmationModalInstance = Modal.getInstance(this.confirmationModalElement);

    // Whenever an input gets changed the form will be dirty, causes it to trigger a confirm modal when needed.
    this.inputs = this.formElement.querySelectorAll("input");
    this.textAreaInputs = this.formElement.querySelectorAll("textarea");

    // We want to manually trigger the confirmation modal on a click event on the trigger button.
    this.triggers = this.formElement.querySelectorAll(".js-modal-confirmation-trigger");

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        this.formDirty = true;
        this.modal.hide();
      });
    });

    this.inputs.forEach((input) => {
      input.addEventListener(
        "change",
        () => {
          this.formDirty = true;
        },
        { once: true }
      );
    });

    this.textAreaInputs.forEach((input) => {
      input.addEventListener(
        "change",
        () => {
          this.formDirty = true;
        },
        { once: true }
      );
    });

    this.modalElement.addEventListener("hidden.bs.modal", () => {
      if (!this.confirmationModalInstance._isShown) {
        this.disposeModal();
      }
    });

    this.confirmationModalElement.addEventListener("hidden.bs.modal", (e) => {
      if (!this.modal._isShown) {
        this.disposeModal();
      }
    });

    this.modalElement.addEventListener("hide.bs.modal", () => {
      const modalDropdownElement = document.querySelector(".select-dropdown");
      if (modalDropdownElement) {
        modalDropdownElement.remove();
      }

      if (this.formDirty) {
        this.confirmationModalInstance.show();
      }
    });

    this.confirmationModalElement.addEventListener("modal:keep-changes", () => {
      this.modal.show();
    });
  }

  handleSuccesfulSubmission() {
    this.formDirty = false;
    this.modal.hide();

    if (this.confirmationModalInstance) {
      this.confirmationModalInstance.hide();
    }
  }

  disposeModal() {
    this.modalWrapperElement.remove();
    this.modal.dispose();

    if (this.confirmationModalInstance) {
      this.confirmationModalInstance.dispose();
    }
  }
}
